import { createContext, useContext, useState } from "react";

import { data } from "../data/accounts";
import { data2 } from "../data/accounts2";
import * as accountUtils from "../util/accountUtils";

const GraphContext = createContext();

let initialGraph = { nodes: [], edges: [] };
initialGraph = accountUtils.connectInstitutionToAccounts(data, initialGraph);
initialGraph = accountUtils.connectInstitutionToAccounts(data2, initialGraph);
initialGraph = accountUtils.connectProfileToInstitutions(initialGraph);

const GraphProvider = ({ children }) => {
  const [graph, setGraph] = useState(initialGraph);

  return (
    <GraphContext.Provider value={{ graph, setGraph }}>
      {children}
    </GraphContext.Provider>
  );
};

export const useGraphContext = () => useContext(GraphContext);
export default GraphProvider;
